import React, { forwardRef, useEffect, useState } from "react";
import { CalendarOptions, LocaleInput } from "@fullcalendar/common";
import FullCalendar from "@fullcalendar/react";
import { useLocalizationStore } from "../../../stores/localizationStore";
import { getFCLocale } from "./FullCalendar.helpers";

export const LocalizedFullCalendar = forwardRef<FullCalendar, CalendarOptions>((props, ref) => {
    const appLocale = useLocalizationStore((state) => state.locale);
    const [locale, setLocale] = useState<LocaleInput>();

    useEffect(() => {
        setLocale(undefined);

        /** We don't need any localization for "English" */
        if (appLocale === "en" || appLocale === "en_US") return;

        getFCLocale(appLocale).then(setLocale);
    }, [appLocale]);

    return <FullCalendar ref={ref} {...props} locale={locale} />;
});
